import React from 'react';
import { Col, Row } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'components/ui/button';
import { faBolt, faRectangleHistoryCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import AddToList from '../properties/add_to_list';
import PropertyBookmark from '../search/components/results/property_bookmark';
import { useDispatch, useSelector } from 'react-redux';
import { selectCallListId, selectCallListItemId } from '../store/selectors/call_console';
import { CALL_CONSOLE, callListUrl, deleteCallListItem } from 'bundles/connect/helpers/prospect_api';
import { displayToast } from 'bundles/connect/helpers/display_toast';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { selectCallListItems, selectTotalPages, selectPage } from '../store/selectors/results';
import { setCallListItems, setPage, setTotalPages } from '../store/actions/results';
import { setOffMarketPropertyIdPayload } from '../store/actions/off_market_property';

type Props = {
  bookmarked: boolean;
  insightsPropertyId: string;
  products: {
    prospecting: boolean;
  };
}

export default function PropertyActions({
  bookmarked,
  insightsPropertyId,
  products
}: Props) {
  const dispatch = useDispatch();
  const callListId = useSelector(selectCallListId);
  const callListItemId = useSelector(selectCallListItemId);
  const callListItems = useSelector(selectCallListItems);
  const totalPages = useSelector(selectTotalPages);
  const page = useSelector(selectPage);

  const handleRemoveFromList = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (confirm('Are you sure?')) {
      deleteCallListItem(callListItemId).then(() => {
        const newItems = callListItems.filter(item => item.id !== callListItemId);
        dispatch(setCallListItems(newItems));
        if (newItems.length === 0 && page > 1) {
          dispatch(setPage(page - 1));
          dispatch(setTotalPages(totalPages - 1));
        }
        dispatch(setOffMarketPropertyIdPayload(""));
        displayToast('Item successfully removed from list', 'success');
      }).catch(() => {
        displayToast('Something went wrong, please try again', 'error');
      });
    }
  };

  return (
    <Row className="gx-2">
      {products.prospecting && (
        <>
          <Col className="d-flex align-items-center" xs="auto">
            {callListId ?
              <Button
                className="squared text-danger"
                icon={faTrash}
                tooltip="Remove from List"
                tooltipPlacement="left"
                variant="ghost"
                onClick={handleRemoveFromList}
              /> :
              <PropertyBookmark bookmarked={bookmarked} id={insightsPropertyId} />
            }
          </Col>
          <Col xs="auto">
            {callListId ? (
              <Button
                href={`${callListUrl(CALL_CONSOLE, callListId)}?item_id=${callListItemId}`}
                icon={faBolt}
                label="Start Outreach"
              />
            ) :
              (
                <AddToList
                  itemCount={1}
                  itemIds={new Set([insightsPropertyId])}
                  tooltip={false}
                >
                  <Button>
                    <FontAwesomeIcon className="me-1" icon={faRectangleHistoryCirclePlus} /> Add To List
                  </Button>
                </AddToList>
              )}
          </Col>
        </>
      )}
    </Row>
  );
}
